import debounce from 'lodash/debounce';
import {
    onBetPlaced,
    isBetslipReceiptOpen,
    isBetslipOpen,
    onBeforeBetslipSync,
} from '../../shared/utils/betslip';
import { isLargeContainer } from '../../spa/Utils/ContainerSize';
import createRecommendationsView from '../../shared/components/recommendations-view/createRecommendationsView';
import {
    BETSLIP_RECEIPT_RECOMMENDER_CSS_ID,
    RECOMMENDATION_BETSLIP_RECEIPT_GA_COMPONENT_NAME,
    RECOMMENDATION_LOCATION_BET_RECEIPT_NAME,
} from './constants';
import {
    addRecommendedFlagToBetslipSelection,
    getRecommendSelectionsDelay,
} from './utils';
import {
    getSelectionRecommendations,
 } from '../../shared/services/recommendations';
import {
    setAsGaComponent,
} from '../../shared/utils/google-analytics';

/**
 * The betslip receipt recommendations is wrapped in this function so it can be
 * initilaized only after bbClientState has been initialized because it depends on the
 * delay state from bbClientState
 * @return {void}
 */
export function initilaizeBetslipReceiptRecommendations() {
    const gtmReceipt = true; //so GTM tag knows whether the receipt or betslip is showing

    let eventListeners = [];

    /**
     * The recommendations view
     * @type {RecommendationsView}
     */
    const recommendationsView = createRecommendationsView(gtmReceipt);

    /**
     * Recommend selections when a user adds selections to the betslip
     * @return {void}
     */
    const recommendBetslipReceiptSelections = debounce((betReceiptSelections) => {
        const container = document.getElementById(BETSLIP_RECEIPT_RECOMMENDER_CSS_ID);

        if (container === null) {
            return;
        }

        if (!container.contains(recommendationsView.el)) {
            container.appendChild(recommendationsView.el);
        }

        if ((isBetslipOpen() || isLargeContainer()) && isBetslipReceiptOpen()) {
            getSelectionRecommendations(betReceiptSelections, RECOMMENDATION_LOCATION_BET_RECEIPT_NAME)
                .then(recommendationsView.setSelections)
                .catch(recommendationsView.clear);
        }
    }, getRecommendSelectionsDelay());

    const onBetPlacedEvent = onBetPlaced(({ userBetslipSelection }) => {
        recommendationsView.clear();
        recommendBetslipReceiptSelections(Object.keys(userBetslipSelection));
    });
    eventListeners.push(onBetPlacedEvent);

    const onBeforeBetslipSyncEvent = onBeforeBetslipSync(({ userBetslip }) => {
        if (isBetslipReceiptOpen() || isLargeContainer()) {
            addRecommendedFlagToBetslipSelection({ userBetslip, recommendationsView });
        }
    });
    eventListeners.push(onBeforeBetslipSyncEvent);

    setAsGaComponent(recommendationsView.el, RECOMMENDATION_BETSLIP_RECEIPT_GA_COMPONENT_NAME);

    const destroy = () => {
        eventListeners.forEach(
            (fn) => fn(
                (unsubscribe) => unsubscribe()
            )
        );
        recommendationsView.clear();
    };

    return {
        destroy,
    };
}
